/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable camelcase */
import { net } from 'zf-web-infra';
import { createWWLoginPanel, WWLoginType, WWLoginRedirectType, WWLoginPanelSizeType } from '@wecom/jssdk';
import type { WWLoginSuccessResp } from '@wecom/jssdk';
import type * as Types from '../types';

export class WeComLoginService {

  async init(tenant: string, config: Types.WeComLoginSettingResponse): Promise<WWLoginSuccessResp> {
    const { corpId, agentId } = config;
    const redirect_uri = this.getRedirectUrl(tenant);
    return await new Promise((resolve, reject) => {
      createWWLoginPanel({
        el: '#login-qrcode',
        params: {
          login_type: WWLoginType.corpApp,
          redirect_uri,
          appid: corpId,
          agentid: agentId,
          state: 'wecomQRLogin',
          redirect_type: WWLoginRedirectType.callback,
          panel_size: WWLoginPanelSizeType.small
        },
        onLoginSuccess(result) {
          resolve(result);
        },
        onLoginFail(err) {
          reject(err);
        }
      });
    });
  }

  async login(params: Types.WecomLoginParams): Promise<Types.LoginResponse> {
    return await net.post<Types.LoginResponse>('/api/account/wecomQRLogin', params);
  }

  async autoLogin(params: Types.WecomLoginParams): Promise<Types.LoginResponse> {
    return await net.post<Types.LoginResponse>('/api/account/wecomAutoLogin', params);
  }

  async fetchAutoLoginConfig(params: { tenant: string; app: string }):
  Promise<Types.WeComLoginSettingResponse> {
    return await net.post<Types.WeComLoginSettingResponse>('/api/account/wecomAutoLoginSetting', params);
  }

  async fetchConfig(params: { tenant: string; app: string }): Promise<Types.WeComLoginSettingResponse> {
    return await net.get<Types.WeComLoginSettingResponse>('/api/account/wecomQRLoginSetting', params);
  }

  createOAuthUrl(params: Types.WecomOAuthParams): string {
    const oauthUrl = new URL('https://open.weixin.qq.com/connect/oauth2/authorize');
    oauthUrl.searchParams.set('appid', params.corpId);
    oauthUrl.searchParams.set('redirect_uri', params.redirectUri);
    oauthUrl.searchParams.set('response_type', 'code');
    oauthUrl.searchParams.set('scope', 'snsapi_base');
    oauthUrl.hash = 'wechat_redirect';
    return oauthUrl.toString();
  }

  private getRedirectUrl(tenant: string): string {
    return `${window.location.origin}/login?tenant=${tenant}&type=wecom`;
  }

}
